import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/icon/iconfont.css"
import ElementUI from 'element-ui';
import axios from "axios";
// 引入VueI18n
import i18n from './lang/index'
import API from "./api/api"
import VueQuillEditor from 'vue-quill-editor' 
import 'quill/dist/quill.core.css'
 
import 'quill/dist/quill.snow.css'
 
import 'quill/dist/quill.bubble.css'
import './assets/style.css' //全局单词首字母大写
import Dropdown from './components/dropdownBox.vue';

Vue.component('Dropdown', Dropdown);
 
Vue.use(VueQuillEditor) // 注册富文本编辑器



  // Vue.config.productionTip =false

//el-tabel  使用千分位格式
import {stateFormat,handleScopeFormat,stateFormat2} from './util/thousands'
import {$addStorageEvent} from '../src/util/processingData'
Vue.prototype.stateFormat = stateFormat
Vue.prototype.stateFormat2 = stateFormat2
Vue.prototype.handleScopeFormat = handleScopeFormat


// element-ui 为了兼容vue-i18n@6.x
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})





Vue.prototype.$axios = axios
Vue.prototype.$API = API
Vue.use(ElementUI);

Vue.config.productionTip = false

// //监听localstorage
Vue.prototype.$addStorageEvent = $addStorageEvent






window.a = Vue

console.log = ()=>{}  //全局关闭打印
window.vm = new Vue({
  router,
  store,
  //添加进Vue实例里面
  i18n,
  render: h => h(App)
}).$mount('#app')
